import {UserRole} from "../../user/models/model";

// For access control in ProviderPage
export const ProviderAccess = [
    UserRole.PLATFORM
]